import { I18N, t } from './i18n/index.js';
import { S } from './state.js';
import { toast } from './ui.js';

export function tpl(type,lang){
  const ov=S.templates[lang]&&S.templates[lang][type];
  if(ov&&(ov.s||ov.b))return{s:ov.s??I18N[lang]['tpl.'+type+'.s'],b:ov.b??I18N[lang]['tpl.'+type+'.b']};
  const d=I18N[lang]||I18N.en;
  return{s:d['tpl.'+type+'.s'],b:d['tpl.'+type+'.b']};
}
export function fillTpl(str,vars){let s=str;for(const k in vars)s=s.split('{'+k+'}').join(vars[k]??'');return s.replace(/\{[a-zA-Z]+\}/g,'—')}
export function payDetails(){
  const p=[];const st=S.settings;
  if(st.iban)p.push('IBAN: '+st.iban+(st.bank?' ('+st.bank+')':''));
  if(st.paypal)p.push('PayPal: '+st.paypal);
  return p.join('\n');
}

/* ---------- comms ---------- */
export function waLink(phone,text){const digits=(phone||'').replace(/[^\d]/g,'');return 'https://wa.me/'+digits+'?text='+encodeURIComponent(text)}
export function mailtoLink(email,subject,body){return 'mailto:'+encodeURIComponent(email||'')+'?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body)}
export async function copyText(txt){
  try{await navigator.clipboard.writeText(txt);toast(t('c.copied'));return true}
  catch(e){const ta=document.createElement('textarea');ta.value=txt;document.body.appendChild(ta);ta.select();try{document.execCommand('copy');toast(t('c.copied'))}catch(e2){}ta.remove();return true}
}
export async function copyRich(html,txt){
  try{
    const item=new ClipboardItem({'text/html':new Blob([html],{type:'text/html'}),'text/plain':new Blob([txt],{type:'text/plain'})});
    await navigator.clipboard.write([item]);toast(t('c.copied'));
  }catch(e){copyText(txt)}
}
export function download(name,content,mime){
  const blob=new Blob([content],{type:mime||'text/plain;charset=utf-8'});
  const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=name;a.click();
  setTimeout(()=>URL.revokeObjectURL(a.href),4000);
}

/* ---------- ICS ---------- */
